import OrchestratorAPI from '../common';

import {
  CreateValues,
  Payload,
} from '../../models/orchestrator/copilot/session';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/copilot/sessions';

  async createSession(values: CreateValues): Promise<Payload> {
    const url = this.constructPath('/');
    const { session, job } = await this.common.postJSON(url, values);
    return { session, job };
  }

  async getSessions(): Promise<Payload[]> {
    const url = this.constructPath('/');
    return this.common.getJSON(url);
  }

  async destroySession(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return this.common.deleteJSON(url);
  }
}
